(function (window, document) {
  "use strict";

  var HOUR_MS = 60 * 60 * 1000;
  var SHOWN_KEY = "puzodyssey_founding_offer_shown_v1";
  var DISMISSED_AT_KEY = "puzodyssey_founding_offer_dismissed_at_v1";

  function reachedScrollThreshold(scrollY, viewportHeight, documentHeight, threshold) {
    var scrollable = Math.max(1, Number(documentHeight || 0) - Number(viewportHeight || 0));
    return Number(scrollY || 0) / scrollable >= Number(threshold || 0);
  }

  function shouldSuppress(options) {
    var endTime = Date.parse(options.endAt || "");
    var path = String(options.pathname || "").replace(/\/$/, "") || "/";
    var dismissedAt = Number(options.dismissedAt || 0);
    var dismissWindow = Number(options.dismissHours || 24) * HOUR_MS;

    if (Number.isFinite(endTime) && Number(options.now) >= endTime) return true;
    if (options.knownPurchaser || Number(options.cartCount || 0) > 0) return true;
    if (options.sessionShown) return true;
    if (dismissedAt > 0 && Number(options.now) - dismissedAt < dismissWindow) return true;
    if (path === "/cart" || path.indexOf("/checkout") === 0) return true;
    return false;
  }

  window.PuzFoundingOffer = {
    reachedScrollThreshold: reachedScrollThreshold,
    shouldSuppress: shouldSuppress,
  };

  if (!document || typeof document.querySelector !== "function") return;

  var root = document.querySelector("[data-founding-offer]");
  if (!root) return;

  var modal = root.querySelector("[data-founding-offer-modal]");
  var dialog = root.querySelector("[data-founding-offer-dialog]");
  var closeButton = root.querySelector("[data-founding-offer-close]");
  var scrim = root.querySelector("[data-founding-offer-scrim]");
  var cta = root.querySelector("[data-founding-offer-cta]");
  var endAt = root.dataset.endsAt;
  var delayMs = Number(root.dataset.delayMs || 8000);
  var scrollThreshold = Number(root.dataset.scrollThreshold || 0.4);
  var dismissHours = Number(root.dataset.dismissHours || 24);
  var knownPurchaser = root.dataset.knownPurchaser === "true";
  var initialCartCount = Number(root.dataset.cartCount || 0);
  var previousFocus = null;
  var timerId = null;
  var attemptingOpen = false;
  var isOpen = false;

  function readStorage(storage, key) {
    try {
      return storage ? storage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStorage(storage, key, value) {
    try {
      if (storage) storage.setItem(key, value);
    } catch (error) {
      // Storage may be unavailable in strict privacy modes; the offer still works for this page view.
    }
  }

  function currentOptions(cartCount) {
    return {
      now: Date.now(),
      endAt: endAt,
      sessionShown: readStorage(window.sessionStorage, SHOWN_KEY) === "1",
      dismissedAt: Number(readStorage(window.localStorage, DISMISSED_AT_KEY) || 0),
      dismissHours: dismissHours,
      knownPurchaser: knownPurchaser,
      cartCount: Number(cartCount || 0),
      pathname: window.location && window.location.pathname,
    };
  }

  function removeTriggers() {
    if (timerId !== null) {
      window.clearTimeout(timerId);
      timerId = null;
    }
    window.removeEventListener("scroll", onScroll);
  }

  function dismissFor24Hours() {
    writeStorage(window.localStorage, DISMISSED_AT_KEY, String(Date.now()));
  }

  function openModal() {
    if (!modal || !dialog || isOpen) return;
    removeTriggers();
    writeStorage(window.sessionStorage, SHOWN_KEY, "1");
    previousFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("founding-offer-modal-open");
    isOpen = true;
    window.requestAnimationFrame(function () {
      (closeButton || dialog).focus();
    });
  }

  function closeModal(rememberDismissal) {
    if (!modal || !isOpen) return;
    if (rememberDismissal) dismissFor24Hours();
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("founding-offer-modal-open");
    isOpen = false;
    if (previousFocus && typeof previousFocus.focus === "function") previousFocus.focus();
  }

  function attemptOpen() {
    if (attemptingOpen || shouldSuppress(currentOptions(initialCartCount))) return;
    attemptingOpen = true;
    fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to verify cart state.");
        return response.json();
      })
      .then(function (cart) {
        initialCartCount = Number(cart.item_count || 0);
        if (!shouldSuppress(currentOptions(initialCartCount))) openModal();
      })
      .catch(function () {
        removeTriggers();
      })
      .finally(function () {
        attemptingOpen = false;
      });
  }

  function onScroll() {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var documentHeight = document.documentElement.scrollHeight || 0;
    if (reachedScrollThreshold(scrollY, viewportHeight, documentHeight, scrollThreshold)) attemptOpen();
  }

  function onKeydown(event) {
    if (!isOpen) return;
    if (event.key === "Escape") {
      event.preventDefault();
      closeModal(true);
      return;
    }
    if (event.key !== "Tab" || !dialog) return;
    var focusable = Array.prototype.slice.call(dialog.querySelectorAll("a[href], button:not([disabled])"));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  var initialOptions = currentOptions(initialCartCount);
  var expired = shouldSuppress({
    now: initialOptions.now,
    endAt: initialOptions.endAt,
    sessionShown: false,
    dismissedAt: 0,
    dismissHours: dismissHours,
    knownPurchaser: knownPurchaser,
    cartCount: 0,
    pathname: "/",
  });

  if (expired) {
    root.remove();
    return;
  }

  root.hidden = false;

  if (closeButton) closeButton.addEventListener("click", function () { closeModal(true); });
  if (scrim) scrim.addEventListener("click", function () { closeModal(true); });
  if (cta) cta.addEventListener("click", function () { dismissFor24Hours(); });
  document.addEventListener("keydown", onKeydown);

  if (!shouldSuppress(initialOptions)) {
    timerId = window.setTimeout(attemptOpen, delayMs);
    window.addEventListener("scroll", onScroll, { passive: true });
  }
})(window, document);
